/**
 * Generate a query key for page data fetching
 *
 * Used by React Query for caching and invalidation of page data.
 *
 * @param pageType - The type of page (from PageType enum)
 * @returns Query key string
 */
export const getPageFetchKey = (pageType: string): string => {
  return `page-data-${pageType}`
}
